require('slick-carousel');

let gallery = $('.gallery');

if(gallery.length) {

    gallery.each(function () {

        let galleryContainer = $(this),
            galleryModal = galleryContainer.find('.gallery-overlay-modal'),
            galleryObject = galleryContainer.find('.gallery-object');


        galleryObject.slick({

        });

        galleryModal.on('shown.bs.modal', function () {
            galleryObject.slick('refresh');
            $(window).resize();
        });

    });

}
